import React from 'react';
import FullPageSignup from 'app/common/react/components/growth/unauth/signup/FullPageSignup/FullPageSignup';
import loadable from '@loadable/component';

const UnauthBannerSignupModal = loadable(() =>
  import('app/common/react/components/growth/unauth/UnauthBanner/UnauthBannerSignupModal'),
);

export default function UnauthBannerSignupModalLoader(props) {
  return <UnauthBannerSignupModal {...props} fullPageSignup={FullPageSignup} fallback={<div />} />;
}
